import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { AccountGroup, AccountGroupLocation } from '@galaxy/account-group';
import { ColumnDefinition, CustomCellComponent } from '@vendasta/va-filter2-table';
import { TranslateService } from '@ngx-translate/core';
import { Activity } from '@vendasta/automata';
import { Order } from '@vendasta/sales-orders';
import { CommonModule } from '@angular/common';
import { BusinessInfoCellComponent } from './business-info-cell/business-info-cell.component';

interface ActivityRow {
  activity: Activity;
  accountGroup?: AccountGroup;
  order?: Order;
}

@Component({
  template: ` <automata-business-cell [accountGroup]="accountGroup"></automata-business-cell> `,
  imports: [CommonModule, BusinessInfoCellComponent],
})
export class OrderBusinessInfoCellComponent implements OnInit, CustomCellComponent<ActivityRow> {
  @Input() columnDefinition: ColumnDefinition;
  @Input() translateService: TranslateService;
  @Input() element: ActivityRow;
  @Input() eventEmitter: EventEmitter<any>;
  accountGroup: AccountGroup;

  ngOnInit(): void {
    this.accountGroup = new AccountGroup({
      accountGroupId: this.element.order?.businessId,
      napData: new AccountGroupLocation(this.element.order?.business),
      deleted: this.element.order?.business?.deleted ? new Date() : null,
    });
  }
}
